import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {
  //private subject = new Subject<any>();
  checkGlobalSearch = new EventEmitter();
  invokePatientProfileComponentFunction = new EventEmitter();
  invokeSearchFunction = new EventEmitter();
  subsVar: Subscription;

  invokeLayoutComponentFunction = new EventEmitter();
  subsVarLayout: Subscription;

  constructor() { }
  onPatientProfileComponentButtonClick() {
    this.invokePatientProfileComponentFunction.emit();
  }

  onSearchClick(searchText: string) {
    this.invokeSearchFunction.emit(searchText);
  }

  onLayoutComponentButtonClick() {
    this.invokeLayoutComponentFunction.emit();
  }
}
